export default __webpack_public_path__ + "static/media/meals.cae7ac79.jpg";